const COMMON_ROUTES = Object.freeze({
	root: {
		path: '/',
		name: 'Root',
		meta: {
			layout: 'Default',
		},
		redirect: {
			name: 'Home',
		},
	},
	home: {
		name: 'Home',
		path: 'home',
		component: () => import('@/presentation/views/HomeView.vue'),
	},
	payment: {
		path: '/payment',
		name: 'PaymentRoot',
		redirect: {
			name: 'PaymentPreview',
		},
		children: [
			{
				name: 'PaymentPreview',
				path: 'preview',
				meta: {
					layout: 'Simple',
				},
				component: () => import('@/presentation/views/payment/PreviewPaymentView.vue'),
			},
			{
				name: 'PaymentResult',
				path: 'result/:status',
				component: () => import('@/presentation/views/payment/ResultPaymentView.vue'),
			},
		],
	},
	contactUs: {
		name: 'ContactUs',
		path: '/contact-us',
		props: true,
		meta: {
			layout: 'Default',
		},
		component: () => import('@/presentation/views/ContactUs.vue'),
	},
	termsAndCondition: {
		name: 'TermsAndCondition',
		path: '/terms-and-condition',
		props: true,
		meta: {
			layout: 'Simple',
		},
		component: () => import('@/presentation/views/TermsAndConditions.vue'),
	},
	requestExpired: {
		name: 'RequestExpired',
		path: '/request-expired/:errorType',
		props: true,
		meta: {
			layout: 'Default',
		},
		component: () => import('@/presentation/views/RequestExpiredView.vue'),
	},
	notFound: {
		name: 'NotFound',
		path: '/:pathMatch(.*)*',
		meta: {
			layout: 'Default',
		},
		component: () => import('@/presentation/views/NotFoundView.vue'),
	},
});

export default COMMON_ROUTES;
